module.exports = __webpack_public_path__ + "static/media/mail-footer.eaa436b4.svg";